<template>
  <a-modal
    :visible="visible"
    :title="titleForMobile"
    @ok="$emit('onOk')"
    @cancel="$emit('onClose')"
    :width="widthModal"
    :footer="null"
    :afterClose="afterModalSteps"
    :maskClosable="false"
    :body-style="{
      padding: '0px',
    }"
    centered
  >
    <custom-section-scroll :master-styles="{ height: heightBody }">
      <div
        class="modal__container"
        :data-test="DATA_TEST.TICKET.CREATE_TICKET.FORM"
      >
        <a-steps
          v-if="!active_breakpoint.is_mobile"
          :current="current"
          direction="vertical"
          class="steps"
        >
          <a-step v-for="item in steps" :key="item.title" />
        </a-steps>
        <div
          :class="{
            'steps-content-1': current === 0,
            'steps-content-2': current > 0,
          }"
        >
          <!--Titulo-->
          <p class="title" :class="tipographyTitle.normal">
            {{ title.beforeStrong }}
            <strong :class="tipographyTitle.strong">{{ title.strong }}</strong>
            {{ title.afterStrong }}
          </p>
          <!--Formulario-->
          <a-form layout="vertical" :form="form" class="modal__form">
            <!----------------------PRIMER PASO---------------------------->
            <template v-if="current === 0">
              <div class="form__main-content">
                <!--Selecciona el canal de whatsapp-->
                <a-form-item>
                  <h6 class="semibold-14 text--left mrg-bottom-8">
                    Selecciona el canal de WhatsApp
                  </h6>
                  <a-select
                    v-decorator="['channelCompanyId']"
                    class="form__select"
                    @change="handleChangeChannelCompanyId"
                    placeholder="Seleccione aquí"
                    :size="inputs_size"
                  >
                    <a-select-option
                      v-for="simpleCompany in filterSimpleByChannel({
                        channel: 'whatsapp',
                      })"
                      :key="simpleCompany._id"
                    >
                      {{ simpleCompany.title }}
                      {{
                        simpleCompany.alias ? `( ${simpleCompany.alias} )` : ''
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <!--numero de telefono-->
                <a-form-item>
                  <h6 class="semibold-14 text--left mrg-bottom-8">
                    Seleccione el código e ingrese el número
                  </h6>
                  <div class="contain-inline">
                    <a-input
                      v-decorator="[
                        'phone',
                        {
                          rules: [
                            { min: 7, message: 'Mínimo 7 dígitos.' },
                            { message: 'Máximo 15 dígitos.', max: 15 },
                            {
                              pattern: /^([0-9])*$/g,
                              message: 'Deberían ser números.',
                            },
                          ],
                        },
                      ]"
                      placeholder="987654321"
                      :maxLength="15"
                      @input="onInputPhone"
                      :data-test="
                        DATA_TEST.TICKET.CREATE_TICKET.PHONE_TEXTFIELD
                      "
                      :size="inputs_size"
                    />
                    <a-select
                      show-search
                      v-decorator="[
                        'code',
                        {
                          initialValue:
                            initialCountryCompany._id ||
                            initialCountryCompany.dialCode,
                          rules: [
                            {
                              required: true,
                              message: 'Completa el campo',
                            },
                          ],
                        },
                      ]"
                      class="form__select--code"
                      :filter-option="false"
                      @search="handleSearchCode"
                      @popupScroll="handleScrollCode"
                      @blur="handleBlurCode"
                      @change="(countryId) => handleCountry('_id', countryId)"
                      @dropdownVisibleChange="handleOpenDropdown"
                      :size="inputs_size"
                    >
                      <a-select-option
                        v-for="localCountry in localCountries"
                        :key="localCountry._id"
                        :title="localCountry.nameSpanish"
                        :label="localCountry.dialCode"
                      >
                        <img
                          :src="localCountry.icon4x3"
                          height="20px"
                          width="20px"
                          role="img"
                          :aria-label="localCountry.nameSpanish"
                          class="select__flag"
                        />
                        <span v-if="isOpenDropdown">
                          {{ localCountry.nameSpanish }}</span
                        >
                        {{ localCountry.dialCode }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-form-item>
                <!--seleccionar cola-->
                <a-form-item>
                  <h6 class="semibold-14 text--left mrg-bottom-8">
                    Selecciona la cola de destino
                  </h6>
                  <a-select
                    v-decorator="['lineId']"
                    class="form__select"
                    @change="handleLine"
                    placeholder="Seleccione aquí"
                    :data-test="DATA_TEST.TICKET.CREATE_TICKET.QUEUE_SELECT"
                    :size="inputs_size"
                  >
                    <a-select-option v-for="line in arrLines" :key="line._id">
                      {{ line.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </template>
            <!---------------SEGUNDO PASO------------------------>
            <div v-if="current === 1" class="form__main-content">
              <a-form-item label="">
                <a-select
                  v-decorator="['template']"
                  class="form__select"
                  @change="handleTemplate"
                  placeholder="Escoge una plantilla"
                  :data-test="DATA_TEST.TICKET.CREATE_TICKET.TEMPLATE_SELECT"
                  :size="inputs_size"
                >
                  <a-select-option
                    v-for="assigned_template in assigned_templates"
                    :key="assigned_template._id"
                  >
                    {{ assigned_template.friendlyName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <!--------------------TERCER PASO------------------------->
            <custom-section-scroll
              v-if="current === 2 && templateSelected"
              :master-styles="{
                height: active_breakpoint.is_mobile ? 'auto' : '29em',
              }"
              :contentStyles="{
                width: active_breakpoint.is_mobile ? 'auto' : '390px',
              }"
            >
              <div class="form__main-content">
                <a-alert
                  v-if="showAlert"
                  :message="alertMessage"
                  type="error"
                  show-icon
                  style="margin-bottom: 10px; width: 100%"
                />
                <a-form-item
                  v-for="param in templateSelected.parameters"
                  :key="`param${param.idParameter}`"
                  :label="param.title"
                  class="margin-bottom-12 padding-btn-0"
                >
                  <a-input
                    v-model="param.value"
                    @input="replaceParamsBody"
                    placeholder="Escribe aquí"
                    :data-test="
                      DATA_TEST.TICKET.CREATE_TICKET.DYNAMIC_TEXTFIELD
                    "
                    class=""
                    :size="inputs_size"
                  />
                </a-form-item>
              </div>
            </custom-section-scroll>

            <div
              v-if="current === 0 && !active_breakpoint.is_mobile"
              class="mobile--empty form__mobile display-flex align--end"
            >
              <svg width="1226" height="710" viewBox="0 0 1226 710" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:width="'224px'" v-bind:height="'130px'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M459.9 468.5c-9.6-5.1-17.8-2.7-26.8 6.9 4.1-23.2 4-51.3-14.4-56-18.9-4.9-29.6 6.9-40.7 35.4.4-24.4-4.4-55.9-24.6-57.2-22.7-1.4-30.3 17.3-35.9 58.8-7.1-23.2-26.6-63.9-49.6-55.8-22.5 7.9-21 29.6-8.5 73.8-12.3-19.1-37-47.5-53.5-36.7-15.7 10.2-11.4 26.9 6 57.9-11.5-5-23.4-5.5-33 3.9-21.5 21.2-11.1 41.3 18.6 78.6 29.8 37.3 243.7-28.7 253.8-45.5 10.2-16.9 26.1-54.7 8.6-64.1z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M326.229 409.79c-4.13 7.509-7.14 17.909-9.726 33.104l-.18 1.068-.022-.058c-4.123-10.479-9.429-20.828-15.2-28.887-10.504-14.669-22.127-21.497-34.198-17.246-12.106 4.25-18.248 12.433-19.333 25.415l-.064.868c-.566 8.61.893 19.335 4.586 34.508l.201.826-.257-.322c-5.092-6.327-10.55-12.087-15.892-16.534-11.913-9.916-22.927-13.207-31.888-7.341-8.755 5.688-12.198 13.515-10.741 24.07l.057.398c1.144 7.712 4.81 17.03 11.529 29.748l.435.821-.252-.064c-10.796-2.677-20.555-.57-28.483 7.193-11.362 11.203-14.684 22.625-10.68 36.252l.22.728c3.585 11.564 12.063 24.598 28.812 45.632 14.426 18.057 66.43 15.49 137.33-1.413 58.151-13.863 115.556-34.71 121.388-44.41 6.24-10.34 12.228-24.04 15.033-35.707 3.788-15.754 1.936-27.467-7.585-32.581l-.367-.192c-8.178-4.212-15.696-3.637-23.226 1.644l-.421.299.062-.497c1.21-10.079 1.267-19.383-.074-27.159-2.168-12.573-7.955-20.931-17.851-23.459l-.596-.15c-16.464-4.031-27.553 3.228-37.828 24.007l-.36.734-.011-.175c-.632-9.015-2.068-17.355-4.375-24.316-4.406-13.292-11.876-21.292-22.68-21.987-12.398-.765-21.116 4.049-27.171 14.838l-.192.345zm26.986-9.195c14.925.96 22.293 23.189 21.785 54.156-.055 3.346 4.58 4.257 5.795 1.138 11.215-28.796 20.992-37.774 37.152-33.584 13.699 3.499 17.241 24.04 12.198 52.574-.519 2.937 3.103 4.75 5.143 2.573l.659-.691c7.983-8.232 14.613-9.825 22.545-5.611 6.365 3.419 7.799 12.489 4.578 25.887-2.649 11.018-8.394 24.163-14.339 34.013-1.93 3.211-16.576 10.327-38.182 18.173-22.934 8.328-51.56 16.846-79.458 23.497-68.07 16.228-119.074 18.746-131.248 3.508l-2.013-2.541c-15.277-19.379-22.922-31.455-25.952-41.77-3.361-11.437-.699-20.591 9.128-30.28 7.841-7.678 17.851-8.436 29.697-3.285 2.636 1.146 5.219-1.713 3.813-4.22-18.014-32.092-19.871-45.542-6.982-53.916 11.687-7.649 32.533 9.705 49.343 35.809 1.866 2.898 6.347.876 5.409-2.441-13.32-47.1-12.112-63.58 6.607-70.153 8.901-3.134 18.2 2.328 27.33 15.079 7.495 10.467 14.271 25.252 18.408 38.769.942 3.078 5.411 2.713 5.842-.477 5.866-43.474 13.673-57.383 32.742-56.207z" fill="#FFB039"/><path fill-rule="evenodd" clip-rule="evenodd" d="M461.6 531.8l.2-.6-287.7.9.2.6c-15.3 3-26.2 17.6-23.7 33.7l21.5 138.8 291.6-.9 21.5-138.8c2.6-16-8.3-30.7-23.6-33.7z" fill="#FFD4BA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M932.799 481.8c-4.5 0-8.999.3-13.399.8-23.9-33-51.301-61-80.101-78.8-75-46.2-177.999-33-274.099 2.6-66.1 24.4-149.8 103.2-203.5 159-70 5.3-123.8 52.9-120.6 107.4.7 11.9 4.1 23.1 9.6 33.4l234.9 1.6c.4-.6.8-1.3 1.2-1.9l348.4-1.2c.4.5.8 1 1.2 1.6l192.9-.3c17.9-23.7 28.6-54 28.6-87.1 0-75.8-56-137.1-125.101-137.1z" fill="#005082"/><path fill-rule="evenodd" clip-rule="evenodd" d="M846.2 408.3c-88.7 55-168.3 56.2-219.9 47.3-47.8-8.2-82.3-26.6-93.5-33.8-1.9 1.1-3.8 2.2-5.8 3.3 9.2 6.3 45.2 27.1 97.2 36.2 17 3 34.1 4.5 51.3 4.5 17.5 0 35-1.5 52.4-4.6 42.1-7.5 83.6-24 123.6-49.1-1.8-1.4-3.5-2.6-5.3-3.8zM837 502.799c14.1-19.8 31.5-30.9 51.8-33.1 9.4-1 17.3.3 22 1.4-1.9-2.4-3.8-4.8-5.7-7.1-4.6-.6-10.3-.9-16.6-.2-15.3 1.6-37.5 9-56.4 35.6-1 1.3-.6 3.2.7 4.2.5.4 1.1.6 1.7.6 1-.1 1.9-.5 2.5-1.4zM838.1 573.1c1.7 0 3-1.3 3.1-2.9.2-8.8 3.7-28.8 16-47.6 14.2-21.9 35.2-35.3 62.2-40.1-1.3-1.8-2.6-3.6-4-5.4-27 5.5-48.8 20-63.3 42.2-12.1 18.6-16.7 39-17 50.7 0 1.7 1.3 3.1 3 3.1zM414.4 543.6c-12.7-.5-24.9.7-33.9 2.6-3 3-6 6-8.9 9 11.1-6.1 74.3-13.7 100.4 16 .6.7 1.4 1 2.3 1 .7 0 1.4-.2 2-.7 1.2-1.1 1.4-3 .3-4.2-16.9-19.3-46.2-23.1-62.2-23.7zM359.7 565.6h.2c-.1-.1-.2 0-.2 0s-.1 0 0 0z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M465.799 586.5c-35.3-26.7-79.3-28.3-97.9-27.5-2.1 2.2-4.2 4.3-6.2 6.4 10.7-.9 61.8-3.3 100.5 25.9.5.4 1.2.6 1.8.6.9 0 1.8-.4 2.4-1.2 1-1.3.7-3.2-.6-4.2zM313.3 705.3s32.8-97 125.1-79.4c92.3 17.6 218.6 55.4 218.6 55.4v24.3l-343.7-.3z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M374.707 629.892c-15.69 7.322-29.138 18.607-40.498 32.763-7.303 9.101-13.309 18.839-18.11 28.579a141.326 141.326 0 00-4.248 9.438l-.489 1.23c-.152.389-.293.757-.423 1.104l-.388 1.062-.094.271a3 3 0 002.84 3.961l343.7.3a3 3 0 003.002-3v-24.3a3 3 0 00-2.14-2.874l-3.991-1.183-5.393-1.582a3118.29 3118.29 0 00-25.346-7.282c-26.618-7.533-54.397-15.065-81.95-22.097a2387.38 2387.38 0 00-40.298-9.929l-3.644-.86c-21.162-4.968-40.694-9.187-58.276-12.54-23.921-4.561-45.325-1.894-64.254 6.939zm63.13-1.045c18.492 3.526 39.174 8.02 61.661 13.344a2390.05 2390.05 0 0140.197 9.905c26.052 6.648 52.31 13.747 77.595 20.869l4.205 1.187c8.455 2.393 16.24 4.63 23.226 6.664l9.278 2.721v19.06l-336.334-.293.274-.66a138.662 138.662 0 013.542-7.757c4.619-9.37 10.399-18.742 17.408-27.477 10.819-13.482 23.567-24.179 38.355-31.08 17.787-8.301 37.91-10.808 60.593-6.483z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1042.1 347s-7.4-3.7-8.3-12.2c-.9-8.5 4.8-45.5 14-50.7 9.3-5.2 51.6-28.1 59.4-27.6 7.8.5 11 68.4-65.1 90.5z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1046.6 288.2c15.8-55.3 28.7-67.7 36.2-62.3 6.8 4.9-7 40.1-11 58.4" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1065.31 232.64l.48-.725c6.4-9.394 13.04-12.573 18.76-8.449 3.38 2.434 3.75 7.462 2.39 15.457l-.19 1.127c-.91 4.945-2.39 10.72-4.82 19.117l-3.97 13.55c-1.86 6.401-2.48 8.801-3.23 12.224a2.995 2.995 0 01-3.57 2.29 3.002 3.002 0 01-2.29-3.571l.28-1.276c.65-2.842 1.31-5.336 2.82-10.569l4-13.652c2.67-9.203 4.21-15.206 5.06-20.24l.12-.76c.81-5.219.56-8.352-.1-8.828-2.3-1.657-5.81.112-10.73 7.601l-.45.688c-6.31 9.923-13.22 27.314-20.39 52.401a2.99 2.99 0 01-3.7 2.06 2.99 2.99 0 01-2.06-3.709l.51-1.795c7.31-25.245 14.39-42.773 21.08-52.941z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1116.3 276.2c7.9-12.9 21-12.2 14.2 9.7-6.7 21.4-11.6 49.2-24.1 61.8-12.5 12.6-17 18.2-17 18.2s-25 93.3-39.2 170.9c-20.5 112.2-59.3 133.8-95.5 120.9-36.2-12.8-42.9-63.6 6.5-162.1 49.4-98.6 75.5-156 75.5-156" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1113.74 274.633c4.49-7.323 11.01-11.43 16.24-9.437 5.76 2.195 6.88 10.02 3.52 21.153l-.73 2.359c-.86 2.852-1.75 5.979-2.93 10.246l-2.18 7.893c-6.35 22.931-11.06 34.677-18.87 42.705l-1.97 1.99a420.153 420.153 0 00-10.28 10.78l-1.1 1.214a144.24 144.24 0 00-2.86 3.241l-.45.529-1.58 5.996-1.42 5.444c-1.38 5.309-2.86 11.123-4.44 17.372-5.71 22.614-11.42 46.274-16.75 69.82l-1.15 5.113a2034.93 2034.93 0 00-6.95 32.175l-.87 4.199c-1.85 9.047-3.56 17.757-5.11 26.093l-.71 3.821c-9.78 53.527-24.18 89.309-42.63 108.881-16.5 17.508-35.977 21.736-56.82 14.308-20.03-7.082-30.825-24.761-30.85-51.738-.026-28.082 11.49-66.023 34.953-113.105l4.612-9.218c18.683-37.396 35.181-71.183 49.435-101.016l5.54-11.643c3.43-7.216 6.53-13.812 9.32-19.772l4.38-9.421 2.88-6.257a2.995 2.995 0 013.97-1.489 2.995 2.995 0 011.56 3.81l-.38.837-3.11 6.766-4.29 9.194c-3.24 6.939-6.91 14.719-11 23.313l-4.2 8.796c-15.08 31.553-32.654 67.472-52.638 107.36-45.376 90.475-45.325 144.793-8.175 157.929 18.655 6.647 35.618 2.965 50.443-12.769 17.33-18.385 31.23-52.658 40.81-104.276l.29-1.569c1.98-10.799 4.22-22.244 6.71-34.253 2.5-12.028 5.22-24.528 8.13-37.393 5.04-22.287 10.43-44.672 15.83-66.179l2.2-8.701c1.02-4.016 2-7.831 2.93-11.423l1.86-7.16 1.59-6.028c.11-.402.3-.778.56-1.102l.41-.5.55-.643c.79-.923 1.77-2.043 2.97-3.364l1.51-1.663c3.16-3.433 7.06-7.511 11.77-12.264l.46-.469c6.4-6.732 10.75-17.234 16.35-37.019l3.6-12.992c.99-3.571 1.79-6.329 2.59-8.933l.36-1.164c2.71-8.701 2.06-13.503.21-14.207-1.84-.703-5.82 1.804-8.98 6.963a3.006 3.006 0 01-4.13.992 3.007 3.007 0 01-.99-4.125z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1037.6 341.3c-7.2-4.9-6.3-33.1-14.4-45.4-10-15.3-19.8-31.2-1.3-28.8 15.9 2 20.9 16 24.6 21" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1008.95 275.585c-2.08-8.374 2.8-12.827 13.32-11.462 8.84 1.111 15.23 5.48 20.41 12.453l.24.332c1.89 2.647 5.49 8.678 5.96 9.369l.03.038a2.99 2.99 0 01-.63 4.196 2.992 2.992 0 01-4.19-.627l-.1-.145c-.86-1.263-4.6-7.526-6.13-9.585-4.27-5.759-9.3-9.193-16.35-10.079-3.67-.477-5.81-.138-6.6.577-.46.423-.62 1.406-.2 3.233l.06.254c1.04 4.19 4.05 9.551 10.6 19.596l.34.515c3.06 4.651 4.94 10.806 6.87 20.648l.39 2.031 1.17 6.347c1.83 9.68 3.26 14.14 5.06 15.478l.09.066a3.001 3.001 0 01-3.38 4.96c-3.75-2.554-5.36-7.274-7.55-18.801l-1.36-7.293-.19-1.02c-1.78-9.257-3.49-14.988-5.96-18.874l-1.86-2.863c-6.04-9.368-8.86-14.576-10.04-19.344z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1107.1 299.6s14.1-34.2 18.8-50.1c5.2-17.3-13-19.8-21.8 5.1" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1120.06 233.231c7.8-.507 11.6 7.089 8.81 16.791l-.09.328c-1.44 4.86-3.8 11.613-6.87 19.819l-.55 1.463c-.42 1.127-.86 2.275-1.31 3.443-1.94 5.1-4.01 10.377-6.1 15.595l-1.71 4.253-1.77 4.362-.6 1.458a2.992 2.992 0 01-3.91 1.63 3.007 3.007 0 01-1.7-3.752l2.42-5.944a1122.118 1122.118 0 006.93-17.561l1.28-3.336.86-2.265c3.2-8.498 5.66-15.495 7.15-20.458l.13-.421c1.91-6.372.33-9.607-2.58-9.418-4.33.281-9.89 6.107-13.52 16.381a3.001 3.001 0 01-5.66-1.999c4.35-12.297 11.61-19.903 18.79-20.369z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1090.5 290.6s27.7-62.7 15.3-68.3c-11.3-5.1-19.9 17.8-34.1 62" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1087.58 232.632c6.02-11.632 12.13-16.371 19.45-13.066 7.54 3.401 6.11 16.387-.63 37.593a297.762 297.762 0 01-3.83 11.236 404.928 404.928 0 01-5.68 14.741l-.73 1.778c-.68 1.65-1.31 3.167-1.89 4.529l-1.03 2.369a2.994 2.994 0 01-3.95 1.532 2.995 2.995 0 01-1.53-3.956l.78-1.804.65-1.528c.45-1.062.92-2.207 1.43-3.426 2.15-5.227 4.3-10.74 6.31-16.279 1.37-3.803 2.64-7.488 3.75-11.009l.49-1.564c5.05-16.346 6.19-27.483 3.4-28.744-3.48-1.567-7.18 1.431-12.05 11.126l-.56 1.132c-4.49 9.223-9.3 22.686-17.4 47.926a3.004 3.004 0 01-5.72-1.836l1.75-5.4c7.41-22.853 11.96-35.288 16.42-44.227l.57-1.123z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M637.799 336.2l3.9 70.7s-6.6 38.2 46.4 31.1c52.8-7 46.3-38.3 46.3-38.3l-16.3-87.8-80.3 24.3z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M717.23 309.029l-80.3 24.3a3.001 3.001 0 00-2.127 3.037l3.884 70.389-.041.32c-.021.176-.043.373-.064.592-.493 5.08.079 10.872 2.573 16.448 6.091 13.619 21.265 20.352 47.342 16.859 21.284-2.822 35.129-9.722 42.722-19.607 5.518-7.184 7.017-14.737 6.287-21.143l-.05-.406a11.47 11.47 0 00-.098-.616l-16.31-87.849a3 3 0 00-3.818-2.324zm-76.306 29.36l74.837-22.647 15.716 84.661c.021.121.043.283.068.5.567 4.983-.628 11.007-5.085 16.809-6.533 8.506-18.934 14.687-38.755 17.315-23.635 3.166-36.169-2.396-41.073-13.361-2.005-4.484-2.479-9.286-2.078-13.42l.045-.422c.023-.199.043-.339.056-.413l.03-.224c.015-.15.018-.301.009-.452l-3.77-68.346z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M738.399 222.7s41-15.4 42.6 27.3c1.6 42.7-42.6 31.6-42.6 31.6" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M742.369 218.428c5.924-1.4 12.035-1.902 17.837-.956 14.131 2.303 23.05 12.641 23.791 32.416.766 20.447-8.337 31.639-23.635 34.987-6.228 1.363-12.786 1.283-18.985.34l-.969-.155a37.304 37.304 0 01-2.739-.55 3 3 0 011.289-5.858l.651.147.31.066c.687.142 1.479.284 2.36.418 5.534.842 11.396.913 16.8-.27 12.518-2.739 19.577-11.418 18.922-28.901l-.046-1.016c-.867-16.25-7.659-23.901-18.714-25.702-4.911-.801-10.272-.36-15.491.873a47.019 47.019 0 00-2.783.746l-.412.127c-.306.096-.558.179-.751.245l-.35.123a3 3 0 01-2.11-5.617l.387-.14c1.041-.368 2.628-.848 4.638-1.323z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M661.5 357.701c-44.4 0-80.4-36-80.4-80.4v-70.2c0-28.4 23.1-51.5 51.5-51.5H703c21.5 0 39 17.5 39 39v82.6c0 44.4-36 80.5-80.5 80.5z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M703 152.601h-70.4c-30.057 0-54.5 24.443-54.5 54.5v70.2c0 46.056 37.343 83.4 83.4 83.4l1.356-.011C708.42 359.951 745 322.777 745 277.201v-82.6c0-23.157-18.844-42-42-42zm-70.4 6H703c19.843 0 36 16.156 36 36v82.6c0 42.3-33.952 76.803-76.217 77.489l-1.308.011c-42.719 0-77.375-34.657-77.375-77.4v-70.2c0-26.744 21.756-48.5 48.5-48.5z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M760.699 315.3c-.1-27.3-3.9-47.2-4.9-52.2 0-.3.1-.7.1-1 0-6.3-5.1-11.4-11.4-11.4v11.4l.3 11.4c2.4-.1 4.6-.9 6.4-2.2 3.7 23 11 91.6-19.8 149.9-5.6 10.7-10.9 20.6-16.1 30.1-29 54.1-48.2 89.9-47.7 121.8 0 1.6 1.4 3 3 3 1.7 0 3-1.4 3-3-.4-30.4 18.5-65.6 47-118.9 5.1-9.6 10.4-19.4 16.1-30.2 20.1-38.1 24.2-80.1 24-108.7zM573.299 274.8c1.4.8 2.9 1.3 4.6 1.4v-22.7c-5.3.5-9.5 4.5-10.2 9.7-.3.5-.5 1.1-.5 1.7 0 4.6 0 112.3 32 160.9 32.7 49.8 42.8 78.2 45.1 126.4.1 1.6 1.4 2.9 3 2.9h.1c1.7-.1 2.9-1.5 2.9-3.1-2.3-49.6-12.6-78.6-46.1-129.5-25.6-38.8-30.1-119.6-30.9-147.7z" fill="#FFB039"/><path fill-rule="evenodd" clip-rule="evenodd" d="M636.849 226a3 3 0 013.042 2.773l.008.176 1.077 63.484.047.018c.218.07.459.055.789-.067l.147-.059c1.543-.659 3.575-2.891 5.907-7.163a3 3 0 015.266 2.876c-5.481 10.037-11.378 12.56-16.089 8.999-.7-.528-1.192-1.072-1.506-1.524a2.99 2.99 0 01-.525-1.44l-.012-.222-1.1-64.8a3 3 0 012.949-3.051zM668.457 301.89a3 3 0 014.512 1.636l.07.248c.074.277.155.641.233 1.084.617 3.516.282 7.405-1.728 11.129-3.35 6.205-10.59 10.25-22.25 11.399a3 3 0 01-.589-5.971c9.819-.968 15.251-4.002 17.559-8.278a10.616 10.616 0 001.118-3.239l.064-.424-.091.05c-13.04 7.023-26.067 7.491-32.523.269l-.215-.246a3 3 0 114.565-3.894c4.641 5.442 16.926 4.318 29.275-3.763zM664.166 202.596c6.546-4.979 14.318-5.511 22.7 1.157a3 3 0 11-3.735 4.695c-6.065-4.824-10.834-4.498-15.332-1.077-.609.463-1.151.937-1.737 1.499l-1.102 1.089a6.523 6.523 0 01-.427.382c-.387.313-.724.524-1.307.67a3 3 0 01-2.531-5.309l.131-.093.657-.653a26.444 26.444 0 012.683-2.36zM684.999 255.8c2.761 0 5-3.447 5-7.7 0-4.252-2.239-7.7-5-7.7s-5 3.448-5 7.7c0 4.253 2.239 7.7 5 7.7zM612.299 257.7c2.761 0 5-3.448 5-7.7 0-4.253-2.239-7.7-5-7.7-2.762 0-5 3.447-5 7.7 0 4.252 2.238 7.7 5 7.7zM598.354 201.648c7.488-5.973 15.7-6.255 22.912 3.009a3 3 0 01-4.734 3.686c-4.869-6.253-9.3-6.102-14.437-2.004a26.096 26.096 0 00-2.016 1.799l-1.179 1.177a6.933 6.933 0 01-.429.391c-.409.341-.73.551-1.344.704a3 3 0 01-2.531-5.309l.115-.082.772-.774c.985-.985 1.856-1.788 2.871-2.597z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M681.599 138.101c-19.5.3-34.3 1.2-43.1 2.9-71.6 16.3-60 69.3-60 69.3s35 6.7 63.5-35.5c0 0 39.1 31.9 97 44.8.9-.2 2-.5 3-.8v2.9c3.4-.9 8.9-1.9 14.6-1.5-.6-20.9-4.4-47.3-21.6-64.3-12.2-12.1-30.2-18.1-53.4-17.8z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M640.087 134.529c11.408-1.585 29.369-2.626 44.844-2.529 30.908.328 51.563 11.716 63.805 31.801 4.819 7.908 8.18 16.907 10.444 27.004 1.671 7.453 2.567 14.283 3.408 23.935a3 3 0 01-5.977.521l-.161-1.795c-1.865-20.148-5.064-33.788-12.837-46.542-11.149-18.292-29.879-28.618-58.732-28.924l-1.763-.006c-14.775-.01-31.528.995-42.206 2.478a3 3 0 01-.825-5.943z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M869.499 94.6c-24.7-70.6-94.7-110.3-156.4-88.7-50.7 17.7-80 71.4-75.2 129.1 9.3-1.6 23.9-2.6 43.7-2.9 24.9-.3 44.3 6.2 57.7 19.5 19 18.8 22.9 47.3 23.4 69.5 9.2 2.5 17.7 10 18.4 28.9.1 1.9-1.6 16.6-1.2 16.5 0 4.7 1 10.6 4.5 16.4 6.9 11.1 20.9 18 41.7 20.4h.4c1.5 0 2.8-1.1 3-2.6.2-1.6-1-3.1-2.6-3.3-18.8-2.2-31.4-8.1-37.3-17.6-2.4-3.8-3.3-7.7-3.6-11.1 5.1 6 14 12.5 28.1 12.5 3.4 0 7.1-.4 11.1-1.2 1.6-.3 2.7-1.9 2.3-3.5-.3-1.6-1.9-2.7-3.5-2.3-18.2 3.8-28.3-3.1-33.6-9.3 4.1-.9 8.1-2 12.1-3.4 61.6-21.7 91.6-96.4 67-166.9zM689.299 210.4c-21.87 0-39.6 17.73-39.6 39.6 0 21.871 17.73 39.6 39.6 39.6 21.871 0 39.6-17.729 39.6-39.6 0-21.87-17.729-39.6-39.6-39.6zm0 6c18.557 0 33.6 15.044 33.6 33.6 0 18.557-15.043 33.6-33.6 33.6-18.557 0-33.6-15.043-33.6-33.6 0-18.556 15.043-33.6 33.6-33.6z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M651.9 246.101a3 3 0 01.176 5.994l-.176.006h-23.8a3 3 0 01-.177-5.995l.177-.005h23.8zM740.523 217.988a3 3 0 013.109 5.129l-.156.095-20.7 11.7a3 3 0 01-3.109-5.129l.156-.095 20.7-11.7z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M590.299 210.4c-21.87 0-39.6 17.73-39.6 39.6 0 21.871 17.73 39.6 39.6 39.6 21.871 0 39.6-17.729 39.6-39.6 0-21.87-17.729-39.6-39.6-39.6zm0 6c18.557 0 33.6 15.044 33.6 33.6 0 18.557-15.043 33.6-33.6 33.6-18.557 0-33.6-15.043-33.6-33.6 0-18.556 15.043-33.6 33.6-33.6z" fill="#273067"/><path fill-rule="evenodd" clip-rule="evenodd" d="M842 667.8h-20.8L811 516.5c-.7-10.6-9.9-19.2-20.5-19.2H500.6c-10.6 0-18.7 8.6-17.9 19.2L494 684c.7 10.6 9.9 19.2 20.5 19.2l327.4-.4c6 0 10.8-4.9 10.8-10.8v-13.3c.1-6-4.7-10.9-10.7-10.9z" fill="#FFB039"/><path fill-rule="evenodd" clip-rule="evenodd" d="M666 597.4c-4.1-4.4-9.6-7.2-15.4-8.3.9-1.3 1.5-2.9 1.7-4.6.5-5.4-3.4-10.4-8.6-11.2h-.3c-1.1-4.1-3.2-10.9-5.6-13.8-.9-1.1-2.6-1.5-3.8-.8-1.1.7-1.3 2.1-.4 3.2 1.6 1.9 3.5 7.8 4.7 12.3-2.7 1.4-4.6 4.1-4.9 7.5-.3 3.1.9 6 2.8 8.1-1.8.6-3.5 1.3-5.1 2.3-10.4 6.5-11.7 19.3-2.9 28.8 8.8 9.4 24.5 11.8 34.9 5.3 10.5-6.5 11.8-19.4 2.9-28.8z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M661.601 559s-15-3-17 9.5c.1 0 11.9 4.2 17-9.5z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1222.9 703.2a3 3 0 01.18 5.995l-.18.005H3.8a3 3 0 01-.176-5.995l.176-.005h1219.1z" fill="#273067"/></svg>
            </div>
            <template v-if="!active_breakpoint.is_mobile">
              <transition name="slide-fade">
                <mobile-wsp
                  v-if="current === 1"
                  :message="message"
                  type="small"
                  class="form__mobile"
                />
              </transition>
              <mobile-wsp
                v-show="current === 2"
                :message="message"
                type="small"
                class="form__mobile"
              />
            </template>
            <preview-message
              v-else-if="
                (current === 1 || current === 2) && active_breakpoint.is_mobile
              "
              :text="message"
            />
          </a-form>
        </div>
      </div>
    </custom-section-scroll>
    <!-------------------BOTONES------------------------------------->
    <div class="modal__footer">
      <a-button
        v-if="current === 0"
        size="large"
        class="width-98"
        @click="hideModal"
        >Cancelar</a-button
      >
      <a-button v-if="current > 0" @click="prev" size="large" class="width-98"
        >Volver</a-button
      >
      <a-button
        v-if="current < steps.length - 1"
        @click="next"
        type="primary"
        size="large"
        class="width-98"
        style="margin-left: 12px"
        :disabled="disabledStep"
        :data-test="DATA_TEST.TICKET.CREATE_TICKET.NEXT_BUTTON"
        >Siguiente</a-button
      >
      <template v-else>
        <a-button
          v-if="current == steps.length - 1"
          type="primary"
          size="large"
          style="margin-left: 12px; min-width: 98px"
          :data-test="DATA_TEST.TICKET.CREATE_TICKET.SEND_BUTTON"
          @click="prepareTemplate"
          :disabled="disabledStep || disabledBtn"
          :loading="loading"
          >Enviar
        </a-button>
      </template>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MobileWsp from '@/app/strategies/components/MobileWsp'
import CustomSectionScroll from '@/app/shared/components/sections/CustomSectionScroll'
import PreviewMessage from '@/app/tickets/components/molecules/PreviewMessage'
import formatMixin from '@/app/shared/mixins/format'
import supportMixin from '@/app/shared/mixins/support'
import { DATA_TEST } from '@/app/shared/utils/dataTest'

export default {
  name: 'ModalNewMessage',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    sectionLine: {
      type: Object,
    },
  },
  components: {
    MobileWsp,
    CustomSectionScroll,
    PreviewMessage,
  },
  data: () => ({
    DATA_TEST,
    current: 0,
    steps: [
      { title: 'first', content: '' },
      { title: 'second', content: '' },
      { title: 'last', content: '' },
    ],
    /** Formato de Codigos de paises para el combo */
    country: {
      countryCodeSelected: null,
      countryCodes: [{ id: 1, text: 'Perú', value: '+51' }],
    },
    phone: '', // Número de telefono destino
    /** Mensaje que se introducirá al fono */
    templateSelected: null, // Plantilla seleccionada
    message: null, // Mensaje preparado, con los parametros completos
    showAlert: false,
    loading: false,
    disabledBtn: false,
    lineId: '',
    arrLines: [], // Lista de colas
    alertMessage: 'El número ingresado tiene un ticket activo',
    localCountries: [],
    scrolledCode: false,
    isOpenDropdown: false,
    channelCompanyIdSelected: null, // id del canal de la empresa seleccionado
    preventChangeInitial: false,
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal' })
  },
  mixins: [formatMixin, supportMixin],
  watch: {
    initialCountryCompany(newvalue, oldValue) {
      // setea el pais seleccionado
      if (oldValue._id !== newvalue._id) {
        // setea el valor inicial para el selector de codigos
        this.setInitialValueToLocalCountries(newvalue)
        this.handleCountry(
          'dialCode',
          this.company && this.company.country
            ? this.company.country.dialCode
            : '+51'
        )
      }
    },
  },
  computed: {
    ...mapGetters([
      'assigned_templates',
      'profile',
      'lines',
      'countries',
      'company',
      'simple_company_channels',
      'inputs_size',
      'active_breakpoint',
    ]),

    /**
     * @return {Boolean} paso deshabilitado o no
     */
    disabledStep() {
      switch (this.current) {
        case 0: {
          if (
            this.country.countryCodeSelected &&
            this.phone.length >= 7 &&
            this.phone.length <= 15 &&
            this.lineId
          )
            return false
          break
        }
        case 1: {
          if (this.templateSelected) return false
          break
        }
        case 2: {
          let full = this.templateSelected.parameters.every(
            (param) => param.value
          )
          return !full
        }
      }
      return true
    },
    /**
     * Valor inicial para el codigo de telefono
     * @return {Object| null}
     */
    initialCountryCompany() {
      const country = this.findCountry(this.company?.country || {})

      return country
    },
    /**
     * @return {String} titulo del modal para mobiles
     */
    titleForMobile() {
      return this.active_breakpoint.is_mobile
        ? `Paso ${this.current + 1}  de 3`
        : null
    },
    /**
     * @return {String} altura del cuerpo del modal
     */
    heightBody() {
      return this.active_breakpoint.is_mobile ? '395px' : 'auto'
    },
    /**
     * @return {String} tipografia para el titulo
     */
    tipographyTitle() {
      return {
        normal: this.active_breakpoint.is_mobile ? 'regular-16' : 'body-4',
        strong: this.active_breakpoint.is_mobile ? 'semibold-16' : 'heading-h5',
      }
    },
    /**
     * @return {String} titulo del modal
     */
    title() {
      switch (this.current) {
        case 0:
          return {
            beforeStrong: 'Empecemos,',
            strong: 'introduce el número telefónico de WhatsApp',
            afterStrong: 'aquí',
          }
        case 1:
          return {
            beforeStrong: 'Ahora,',
            strong: 'selecciona una plantilla',
            afterStrong: 'que más te guste',
          }
        case 2:
          return {
            beforeStrong: 'Finalmente',
            strong: 'completa los parámetros',
            afterStrong: 'de tu plantilla',
          }
        default:
          return null
      }
    },
    /**
     * @return {String} ancho del modal
     */
    widthModal() {
      const breakpoint = this.active_breakpoint.breakpoint
      switch (breakpoint) {
        case 'xs':
          return '374px'
        case 'sm':
          return '374px'
        case 'md':
          return '482px'

        default:
          return 'fit-content'
      }
    },
  },
  methods: {
    ...mapActions([
      'sendTemplate',
      'selectTicket',
      'getLine',
      'getAssignedTemplates',
    ]),
    ...mapMutations(['CLEAN_PARAMETERS_TEMPLATE']),
    next() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.channelCompanyId)
            this.channelCompanyIdSelected = values.channelCompanyId
          this.current++
        }
      })
      if (this.current === 1) {
        setTimeout(() => {
          this.form.setFieldsValue({
            template: this.templateSelected
              ? this.templateSelected._id
              : undefined,
          })
        }, 100)
      }
    },
    prev() {
      this.current--
      this.showAlert = false
      setTimeout(() => {
        if (this.current === 0) {
          this.setInitialValueToLocalCountries({
            ...this.country.countryCodeSelected,
          })
          this.form.setFieldsValue({
            phone: this.phone,
            code: this.country.countryCodeSelected._id,
            lineId: this.lineId,
            channelCompanyId: this.channelCompanyIdSelected,
          })
        }
        if (this.current === 1) {
          this.form.setFieldsValue({
            template: this.templateSelected._id,
          })
        }
      }, 100)
    },
    /**
     * Selecciona el código de país
     * @param {String} key Nombre del atributo a buscar
     * @param {String} value Valor del código seleccionado
     */
    handleCountry(key, value) {
      const index = this.localCountries.findIndex(
        (country) => country[key] === value
      )
      if (index !== -1)
        this.country.countryCodeSelected = {
          ...this.localCountries[index],
          index,
        }
    },
    // se ejecuta mientras escribe el número telefónico
    onInputPhone() {
      this.phone = this.form.getFieldValue('phone')
    },
    /**
     * Selecciona la cola
     * @param {String} value id de la cola seleccionada
     */
    handleLine(value) {
      this.lineId = value
    },
    /**
     * Selecciona una plantilla y se preparan los parametros a completar
     * @param {String} value Valor del id de la plantilla escogida
     */
    handleTemplate(value) {
      this.templateSelected = this.assigned_templates.find(
        (template) => template._id === value
      )
      this.message = this.templateSelected.body
    },
    /** Reemplaza el texto de la plantilla por el mismo mensaje pero con los parametros llenos */
    replaceParamsBody() {
      this.message = this.templateSelected.body
      this.templateSelected.parameters.forEach((param, index) => {
        if (param.value) {
          this.message = this.message.replace(`{{${index + 1}}}`, param.value)
        }
      })
      this.message = this.validCompareTexts(
        this.templateSelected.body,
        this.message
      )
    },
    async prepareTemplate() {
      this.disabledBtn = true
      this.loading = true
      const parameters = this.templateSelected.parameters.map((param) => {
        var rObj = {}
        rObj['default'] = param.value
        return rObj
      })
      const paramsMessage = {
        channelCompanyId: this.channelCompanyIdSelected,
        phoneTo: `${this.country.countryCodeSelected.dialCode}${this.phone}`,
        message: { text: this.message },
        lineId: this.lineId,
        template: { name: this.templateSelected.name, parameters: parameters },
        newMessage: true,
      }
      const response = await this.sendTemplate(paramsMessage)

      if (response.success === false) {
        if (response.result === 'already-assigned') {
          this.showAlert = true
          this.disabledBtn = false
          this.loading = false
          if (response.ticketNumber)
            this.alertMessage = `El número ingresado tiene el ticket #${response.ticketNumber} activo`
          else this.alertMessage = 'El número ingresado tiene un activo 😥'
        } else if (response.result === 'denied') {
          this.$message.error(
            'La cola seleccionada no tiene permisos para enviar la plantilla'
          )
          this.showAlert = true
          this.alertMessage =
            'La cola seleccionada no tiene permisos para enviar la plantilla'
          this.loading = false
          this.disabledBtn = false
        } else if (response.result === 'not_in_sandbox') {
          this.$message.error(
            'Se produjo un error al tratar de enviar el mensaje'
          )
          this.showAlert = true
          this.alertMessage =
            'Este número no se encuentra conectado a la sandbox'
          this.loading = false
          this.disabledBtn = false
        } else {
          this.$message.error(
            'Se produjo un error al tratar de enviar el mensaje'
          )
          this.showAlert = true
          this.alertMessage =
            'Se produjo un error al tratar de enviar el mensaje'
          this.loading = false
          this.disabledBtn = false
        }
        return
      }
      this.$message.success('Mensaje enviado correctamente')
      this.loading = false
      this.disabledBtn = false
      this.cleanTemplate()
      this.hideModal()
    },
    cleanTemplate() {
      this.current = 0
      this.message = null
      this.phone = ''
      this.lineId = null
      if (this.templateSelected) {
        this.CLEAN_PARAMETERS_TEMPLATE(this.templateSelected._id)
      }
      this.templateSelected = null
      this.form.resetFields()
    },
    // despues de cerrar modal, usado desde su componente padre
    clean() {
      this.showAlert = false
      this.cleanTemplate()
      this.country = {
        countryCodeSelected: null,
        countryCodes: [{ id: 1, text: 'Perú', value: '+51' }],
      }
      this.handleCountry('dialCode', this.company.country.dialCode || '+51')
      this.setInitialValueToLocalCountries(this.initialCountryCompany)
    },
    hideModal() {
      this.$emit('onClose')
    },
    /**
     * Carga la lista de colas a la cual está asignado
     */
    async loadArrLines(companyChannelId) {
      const arrLines = []
      for (let i = 0; i < this.profile.company.linesId.length; i++) {
        let lineFound = this.lines.find(
          (line) => line._id == this.profile.company.linesId[i]
        )
        if (!lineFound) {
          lineFound = await this.getLine(this.profile.company.linesId[i])
          if (
            lineFound &&
            lineFound.channels_companies &&
            lineFound.channels_companies.some(
              (channel_company) => channel_company._id === companyChannelId
            )
          )
            arrLines.push(lineFound)
        } else {
          if (
            lineFound &&
            lineFound.channels_companies &&
            lineFound.channels_companies.some(
              (channel_company) => channel_company._id === companyChannelId
            )
          )
            arrLines.push(lineFound)
        }
      }
      this.arrLines = arrLines
    },
    /**
     * Encuentra un país de acuerdo a los datos pasados
     * @param {Object} countryCompany
     * @param {String} countryCompany.code
     * @param {String} countryCompany.name
     */
    findCountry(countryCompany) {
      // si no existen paises
      if (!this.countries.length || !this.company)
        return { dialCode: '+51', default: true }
      let indexInitialCountry = null
      // si existen en la compañia registrada el nombre y codigo de telefono registrados
      if (countryCompany.code && countryCompany.name)
        indexInitialCountry = this.countries.findIndex(
          (country) =>
            country.code === countryCompany.code &&
            country.nameSpanish === countryCompany.name
        )
      else if (countryCompany.code || countryCompany.name) {
        if (!indexInitialCountry)
          indexInitialCountry = this.countries.findIndex(
            (country) =>
              country.code === countryCompany.code ||
              country.nameSpanish === countryCompany.name
          )
      }
      return indexInitialCountry && indexInitialCountry !== -1
        ? {
            _id: this.countries[indexInitialCountry]._id,
            index: indexInitialCountry,
            ...this.countries[indexInitialCountry],
          }
        : { dialCode: '+51', default: true }
    },
    /**
     * Busqueda por codigo o por nombre de pais
     * @param {String} value - valor de busqueda
     */
    handleSearchCode(value) {
      if (!value) return
      value = value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const foundCountries = this.countries.filter(
        (item) =>
          item.nameSpanish
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(value) ||
          item.dialCode
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(value)
      )
      this.localCountries = foundCountries
    },
    /**
     * Setea un valor inicial para los paises locales
     * @param {Object} countryCompany
     * @param {String} countryCompany.code
     * @param {String} countryCompany.name
     */
    setInitialValueToLocalCountries(countryCompany) {
      let start = 0
      let end = 0
      if (countryCompany && !countryCompany.default) {
        const index = this.countries.findIndex(
          (country) => country._id === countryCompany._id
        )
        start = index - 10 < 0 ? 0 : index - 10
        end =
          index + 10 > this.country.length - 1
            ? this.country.length - 1
            : index + 10
        this.localCountries = [...this.countries].slice(start, end)
      } else {
        // para que el listado de paises encontrados no se vea de forma bruca
        setTimeout(() => {
          this.localCountries = [...this.countries].slice(0, end)
        }, 100)
        setTimeout(() => {
          this.localCountries = [...this.countries]
        }, 200)
      }
    },
    /**
     * Evento de scroll de los codigos
     */
    handleScrollCode() {
      if (!this.scrolledCode) {
        this.scrolledCode = true
        this.localCountries = this.countries
      }
    },
    /**
     * Evento para cuando se hace clik fuera del selector de codigos
     */
    handleBlurCode() {
      this.setInitialValueToLocalCountries({
        ...this.country.countryCodeSelected,
      })
      // para que el listado de paises no se vea de forma bruca
      setTimeout(() => (this.scrolledCode = false), 3000)
    },
    /**
     * Detecta cuando el selector de codigos esta abierto o cerrado
     * @param {Boolean} visible
     */
    handleOpenDropdown(visible) {
      this.isOpenDropdown = visible
    },
    /**
     * Escucha el evento de cambio de canal
     */
    handleChangeChannelCompanyId(channelCompanyId) {
      this.getAssignedTemplates(channelCompanyId)
      this.loadArrLines(channelCompanyId)
      this.form.resetFields(['lineId'])
      this.lineId = ''
    },
    afterModalSteps() {
      this.clean()
    },
  },
}
</script>

<style lang="sass" scoped>
.slide-fade-enter-active
  transition: all 1s ease
.slide-fade-enter
  transform: translateX(10px)
  opacity: 0
.slide-fade-leave-active
  display: none

.margin-right-12
  margin-right: 12px
.margin-bottom-12
  margin-bottom: 12px
.padding-btn-0
  padding-bottom: 0px !important
.width-98
  width: 98px

.steps
  width: 32px

.ant-steps-item
  height: 100px
.steps-content-1
  margin-left: 32px
  @include xs
    margin-left: 0px
  @include sm
    margin-left: 0px
  @include md
    margin-left: 0px
.steps-content-2
  margin-left: 32px
  @include xs
    margin-left: 0px
    width: 100%
  @include sm
    margin-left: 0px
    width: 100%
  @include md
    margin-left: 0px
    width: 100%
.modal
  &__container
    padding: 40px
    +flex(row, center, flex-start)
    @include xs
      display: block
      padding: 12px 20px
    @include sm
      padding: 12px 20px
      flex-direction: column
    @include md
      padding: 12px 20px
      flex-direction: column
  &__form
    display: flex
    @include xs
      display: block
    @include sm
      display: block
    @include md
      display: block
  &__footer
    position: absolute
    bottom: 32px
    left: 96px
    @include xs
      position: relative
      bottom: 0px
      left: 0px
      border-top: 1px solid $gray_5
      width: 100%
      padding: 12px
      +flex(row, flex-end, flex-end)
    @include sm
      position: relative
      bottom: 0px
      left: 0px
      border-top: 1px solid $gray_5
      width: 100%
      padding: 12px
      +flex(row, flex-end, flex-end)
    @include md
      position: relative
      bottom: 0px
      left: 0px
      border-top: 1px solid $gray_5
      width: 100%
      padding: 12px
      +flex(row, flex-end, flex-end)
.title
  color: $gray_dark_900
  width: auto
  margin-bottom: 12px
  @include xl
    width: 20em
.contain-inline
  display: flex
  flex-direction: row-reverse
.master-container
  position: relative
  padding-top: 2px
  padding-bottom: 2px
  margin-right: 20px
  .form-container
    height: 256px
    overflow-y: auto
.form-container-alert
  height: 184px !important
  overflow-y: auto
.mobile--empty
  width: 224px
  height: 450px
  @include xs
    display: none
  @include sm
    display: none
  @include md
    display: none
.form__mobile
  margin-left: 44px
.form__select
  min-width: 287px
  @include xs
    min-width: 100%
  @include sm
    min-width: 100%
  @include md
    min-width: 100%
  &--code
    width: 200px
    margin-right: 8px
    @include xs
      width: 100px
    @include sm
      width: 100px
    @include md
      width: 100px
.form__main-content
  width: 390px
  @include xs
    width: auto
  @include sm
    width: auto
  @include md
    width: auto
.select__flag
  margin-top: -6px
  margin-right: 4px
</style>
